const tasks = [
  {
    icon: 'ri-route-line',
    title: 'Развитие сотрудников',
    desc: 'Позволяет сделать развитие конкретным и управляемым.',
  },
  {
    icon: 'ri-links-line',
    title: 'Связь обучения с задачами бизнеса',
    desc: 'Обучение становится инструментом достижения рабочих целей.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Развитие кадрового резерва',
    desc: 'Помогает готовить сотрудников к будущим ролям.',
  },
  {
    icon: 'ri-rocket-line',
    title: 'Подготовка к повышению',
    desc: 'Позволяет определить, какие компетенции необходимо развить до перехода на новую должность.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Удержание сильных сотрудников',
    desc: 'Показывает сотруднику возможности профессионального развития внутри компании.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Адресное обучение',
    desc: 'Компания не обучает всех одинаково, а выбирает необходимые инструменты для конкретного сотрудника.',
  },
  {
    icon: 'ri-radar-line',
    title: 'Контроль прогресса',
    desc: 'Руководитель и сотрудник понимают, что уже сделано и что необходимо сделать дальше.',
  },
];

export default function WhyCompanyNeedsIPR() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Зачем компании нужен ИПР
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Какие задачи решает индивидуальный план развития
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {tasks.map((t, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${t.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{t.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}